const experience = [
  {
    id: 1,
    title: "Specialist: CADD & Informatics",
    company: "Aurigene Pharmaceuticals Services Limited, Bengaluru",
    date: "Mar 2025 - Present",
    description: [
      'Leading the development of the Aurigene.AI platform',
      '➤ Capacity building and establishing in‑house protocols for peptide and antibody design',
      'Working on different CADD projects focusing on peptides and small molecules'
    ],
    skills: [
      "Machine Learning",
      "Python",
      "Pipeline Development",
      "Docker"
    ]
  },
  {
    id: 2,
    title: 'Postdoctoral Researcher',
    company: 'Institut Curie, Paris',
    date: 'April 2024 - Mar 2025',
    description: [
      'Deciphering the recombination patterns during meiosis via DNA double Strand Breaks repair‑associated tracts.',
      '➤ Nanopore sequencing data analysis and detection of modified bases',
      '➤ Set up and develop new workflows on an in‑house cluster with Docker'
    ],
    skills: [
      "Genomics",
      "Machine Learning",
      "Python"
    ]
  },
]

export default experience;